// src/features/reports/components/Reports/components/ReportsFilters.jsx
import React from 'react';
import styles from '../Reports.module.css';

export default function ReportsFilters({ filters, allowedBookingTypes, onChange }) {
  return (
    <div className={styles.filterCard}>
      <div className={styles.filterRow}>

        <div className={styles.filterGroup}>
          <label className={styles.filterLbl}>من تاريخ</label>
          <input
            type="date"
            name="start_date"
            value={filters.start_date}
            onChange={onChange}
            className={styles.filterInput}
          />
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLbl}>إلى تاريخ</label>
          <input
            type="date"
            name="end_date"
            value={filters.end_date}
            onChange={onChange}
            className={styles.filterInput}
          />
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLbl}>الحالة</label>
          <select
            name="status"
            value={filters.status}
            onChange={onChange}
            className={styles.filterInput}
          >
            <option value="all">كل الحالات</option>
            <option value="completed">مكتمل</option>
            <option value="in_progress">قيد التنفيذ</option>
            <option value="confirmed">مؤكد</option>
            <option value="pending">قيد الانتظار</option>
            <option value="cancelled">ملغي</option>
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLbl}>نوع الحجز</label>
          <select
            name="booking_type"
            value={filters.booking_type}
            onChange={onChange}
            className={styles.filterInput}
          >
            <option value="">كل الأنواع</option>
            {allowedBookingTypes.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

      </div>
    </div>
  );
}